import { Navigate } from 'react-router-dom';

import {
  useLeague,
  useLeagueMaxTokens,
  useLeaguePlayerState,
} from '../../hooks';
import { ROUTES } from '../../routes';

import {
  CardDisplay,
  SelectionStatus,
  PurchaseSection,
  TokenSelector,
  SeasonTimer,
  CurrentPrizePool,
  Bonus2x1,
  ClanReferralBonus,
  ClanParallelGame,
  MySelections,
  Cashback,
} from '../../components';

export const Amethyst = () => {
  const { maxTokens } = useLeagueMaxTokens();
  const { league, loading } = useLeague();

  const { main, arena, selectToken } = useLeaguePlayerState();

  if (loading) return null;

  if (!league) {
    return <Navigate to={ROUTES.HOME} replace />;
  }

  return (
    <div className="isg-league-container">
      <SeasonTimer />
      <CurrentPrizePool />

      <Bonus2x1 />
      <Cashback />

      <div className="isg-league-grid">
        <div className="isg-league-left">
          <CardDisplay />

          <SelectionStatus
            used={main.used}
            total={main.total}
            available={main.available}
          />

          <MySelections mode="main" />
        </div>

        <div className="isg-league-right">
          <PurchaseSection onPurchase={() => {}} />

          <TokenSelector
            maxTokens={maxTokens}
            selectedTokens={main.selectedTokens}
            availableSelections={main.available}
            onSelectToken={(token) => {
              selectToken(token, 'main');
            }}
          />
        </div>
      </div>

      {/* <WinnersHistory /> */}

      <ClanReferralBonus />

      <ClanParallelGame league={league} parallelTickets={arena.available} />
    </div>
  );
};
